import axios from 'axios';


export const http = axios.create({
  baseURL: process.env.APP_BASE_URL,
});

export const setAuthToken = (token: string | null) => {
  if (token !== null) {
    http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    return;
  }

  delete http.defaults.headers.common['Authorization'];
};
